export const environment = {
  production: true,
  apiURL: 'https://api.sabemi.com.br/apiportalcliente/v1',
  useCaptcha: true,
  version: 'v1.1.4',
  name: 'Producao',
};
